<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	export default{
		name:"InHt",
		data(){
			return{
				
			}
		}
	}
</script>

<style>
</style>

